/* RESPONSIBLE TEAM: team-workflows */
import Step, { IsCustomerFacing } from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';

export default class SetExpectations extends Step {
  get supportedChannels() {
    return SUPPORTED_CHANNELS.setExpectations;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation, TargetContext.CustomerTicket];
  }

  static get requiredBillingFeature() {
    return 'bot_workflows';
  }

  static createNewStep(store: Store): SetExpectations {
    return store.createRecord('operator/visual-builder/step/set-expectations', {
      type: 'operator/visual-builder/step/set-expectations',
    });
  }

  static get canBeCustomerFacing() {
    return IsCustomerFacing.Yes;
  }
}
